import api from "../api.js";
import toast from "../toaster.js";
import createEntity from "./createEntity.js";
import Vue from "vue";

const state = {
    updateTrainer: false,
    loadTrainer: false,
    trainerProfile: null
};

const mutations = {
    update(state, changes) {
        Object.assign(state, changes);
    },
    loadData(state, data) {
        state.trainerProfile = data;
    }
};

const getters = {
    trainerProfileData(state, getters, rootState, rootGetters) {
        return state.trainerProfile;
    }
};

const root = { root: true };

const actions = {

    async updateTrainer(context, { vm, data }) {
        context.commit("update", { updateTrainer: true });

        await api.updateTrainer(data).then(() => {

            toast.showToasts(vm, 'Trainer Profile Updated Successfully', 'success');

        }).catch((error) => {
            Vue.$log.error(error);
            toast.showToasts(vm, 'Updating Trainer Profile Failed', 'warning')
        }
        )
    },

    async loadTrainerProfile(context) {

        context.commit("update", { loadTrainer: true });

        let data = await api.getTrainerProfile();

        context.commit("loadData", data);

        context.commit("update", { loadTrainer: false });
    },
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}